import AutoCompleteFilter from "../../../../components/AutoCompleteFilter";
import baseService from "../../../../services/baseService";

export const inputsFiltersSuppliers = ({
  localFilterValues,
  handleFilterChange,
}) => [
  {
    label: "Apelido",
    component: (
      <AutoCompleteFilter
        service={baseService}
        columnDataBase="alias"
        model="supplier"
        value={localFilterValues.alias}
        onChange={(selected) => handleFilterChange("alias", selected)}
        placeholder="Filtre os fornecedores pelo apelido"
        isMulti
        isClearable
      />
    ),
  },
  {
    label: "Nome",
    component: (
      <AutoCompleteFilter
        service={baseService}
        columnDataBase="name"
        model="supplier"
        value={localFilterValues.name}
        onChange={(selected) => handleFilterChange("name", selected)}
        placeholder="Filtre os fornecedores pelo nome"
        isMulti
        isClearable
      />
    ),
  },
  {
    label: "CPF/CNPJ",
    component: (
      <AutoCompleteFilter
        service={baseService}
        columnDataBase="cpf_cnpj"
        model="supplier"
        value={localFilterValues.cpf_cnpj}
        onChange={(selected) => handleFilterChange("cpf_cnpj", selected)}
        placeholder="Filtre os fornecedores pelo CPF/CNPJ"
        isMulti
      />
    ),
  },
];
